import {
  VAlert,
  VAppBar,
  VAutocomplete,
  VBtn,
  VBtnGroup,
  VBtnToggle,
  VCard,
  VChip,
  VContainer,
  VDataTable,
  VDateInput,
  VDatePicker,
  VFileInput,
  VProgressCircular,
  VProgressLinear,
  VSelect,
  VSwitch,
  VTab,
  VTextField,
  VTextarea,
} from 'vuetify/components'

export const ouraAliases = {
  OAppBar: VAppBar,
  OContainer: VContainer,

  OTab: VTab,
  OCard: VCard,
  OChip: VChip,
  OAlert: VAlert,
  OSwitch: VSwitch,

  OBtnText: VBtn,
  OBtnError: VBtn,
  OBtnPrimary: VBtn,
  OBtnSecondary: VBtn,
  OBtnTertiary: VBtn,

  OBtnGroup: VBtnGroup,
  OBtnToggle: VBtnToggle,
  ODataTable: VDataTable,

  OSelect: VSelect,
  OTextarea: VTextarea,
  OTextField: VTextField,
  OFileInput: VFileInput,
  ODateInput: VDateInput,
  ODatePicker: VDatePicker,
  OAutocomplete: VAutocomplete,

  OProgressLinear: VProgressLinear,
  OProgressCircular: VProgressCircular,
}

export const ouraDefaults = {
  OAppBar: {
    color: 'primary',

    OSwitch: {
      color: '',
    },
  },
  OContainer: {
    fluid: true,
  },

  OTab: {
    class: 'text-capitalize',
  },
  OCard: {
    variant: 'flat',
  },
  OChip: {
    variant: 'tonal',
    label: true,
  },
  OAlert: {
    variant: 'tonal',
  },
  OSwitch: {
    inset: 'material',
    color: 'primary',
  },

  OBtnGroup: {
    rounded: 'xl',
    density: 'compact',
    border: true,
    divided: true,
    variant: 'flat',
  },
  OBtnToggle: {
    rounded: 'xl',
    density: 'compact',
    border: true,
    divided: true,
  },

  OBtnText: {
    rounded: 'pill',
    variant: 'text',
    class: 'text-capitalize',
  },
  OBtnError: {
    rounded: 'pill',
    variant: 'flat',
    color: 'error',
    class: 'text-capitalize',
  },
  OBtnPrimary: {
    rounded: 'pill',
    variant: 'flat',
    color: 'primary',
    class: 'text-capitalize',
  },
  OBtnSecondary: {
    rounded: 'pill',
    variant: 'outlined',
    class: 'text-capitalize',
  },
  OBtnTertiary: {
    rounded: 'pill',
    variant: 'tonal',
    color: 'primary',
    class: 'text-capitalize',
  },

  OSelect: {
    variant: 'outlined',
    density: 'compact',
  },
  OTextarea: {
    variant: 'outlined',
    density: 'compact',
  },
  OTextField: {
    variant: 'outlined',
    density: 'compact',
  },
  OFileInput: {
    variant: 'outlined',
    density: 'compact',
  },
  ODateInput: {
    variant: 'outlined',
    density: 'compact',
  },
  ODatePicker: {
    variant: 'outlined',
    density: 'compact',
  },
  OAutocomplete: {
    variant: 'outlined',
    density: 'compact',
  },

  ODataTable: {
    hover: true,
    // TODO: Not all data tables should be compact density, discuss with designer
    // density: 'compact',
    mobileBreakpoint: 'sm',
  },

  OProgressLinear: {
    color: 'primary',
  },
  OProgressCircular: {
    indeterminate: true,
    color: 'primary',
  },
}
